import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { Col, Row, Surface, TextBody } from '../../atoms';
import { BucketImage, Hypertext } from '../../molecules';
export function AdCard({ description, icon, title, url }) {
    return (_jsxs(Surface, { variant: "tertiary", style: $.container, children: [_jsxs(Col, { children: [!!icon && (_jsx(Col, { mb: "6", children: _jsx(BucketImage, { responsive: false, height: 24, width: 24, path: icon }) })), _jsx(TextBody, { em: true, children: title }), _jsx(TextBody, { mt: "2", children: description })] }), _jsx(Row, { mt: "6", children: _jsx(Hypertext, { href: url, color: "primary", children: "Learn more" }) })] }));
}
const $ = StyleSheet.create({
    container: {
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: 228,
        width: 754,
    },
});
